// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1XDom","itemTitle":"ClientEmergencyInfo_itemTitle__hCLNc","itemText":"ClientEmergencyInfo_itemText__rn-42"};